import { Box, BoxProps } from "@mui/material";
import { PropsWithChildren } from "react";

interface IProps extends BoxProps {
    /**
     * The maximum width of the container.
     *
     * @default "sm"
     */
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const DialogFormContainer = (props: PropsWithChildren<IProps>) => {
    const { children, maxWidth = "sm", ...rest } = props;

    return (
        <Box
            {...rest}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            flexGrow={1}
        >
            <Box width={"100%"} maxWidth={maxWidth} marginX={"auto"}>
                {children}
            </Box>
        </Box>
    );
};
